<div *ngIf="!disabled" class="form-control grid-form-control">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
<!--
    TASK 8961:
    when a payline has been edited in the detail editor, that payline is considered "detailed".
    edits are no longer allowed in the grid. to communicate this to the user and to allow them to
    easily get back to the editor, clicking on any field will display the drop down
    that contains the View/Edit Pay option.
-->
<!-- task 13616
  for manual check paylines, display the view/edit pay when clicking on any cell
-->
<div
  *ngIf="disabled"
  class="no-caret"
  ngbDropdown
  #moreActionsDropdown="ngbDropdown"
  container="body">
  <div
    class="form-control grid-form-control disabled-cell detailed"
    id="moreActionsDropdown"
    ngbDropdownAnchor
    (click)="moreActionsDropdown.open()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    <div ngbDropdownMenu aria-labelledby="moreActionsDropdown">
      <button
        ngbDropdownItem
        (click)="openPaylineDetails(params)"
        cpGTagEvent
        [params]="{ event_label: 'grid_view_edit_payline' }">
        View/Edit Pay
      </button>
    </div>
  </div>
</div>

<ng-template #content>
  <!--
    Task 8941, some values edited in the payline detail editor cannot be properly displayed on the grid. Hide the cell value here and force user to enter detail editor to view/edit the payline
  -->
  <span
    *ngIf="
      params.mode == 'currency' ||
      params.mode == 'number' ||
      params.mode == 'per-hour' ||
      params.mode == 'percent' ||
      params.mode == 'text'
    ">
    <span *ngIf="hasValue() && params.mode == 'currency'">$</span>
    {{ formatNumber() }}
    <span *ngIf="hasValue() && params.mode == 'percent'">%</span>
    <span *ngIf="hasValue() && params.mode == 'per-hour'">
      <small>/hr</small>
    </span>
  </span>
</ng-template>
